const assert = require('#utils/browser-assert')


function bboxContainsPoint(bbox, point) {
  return point.x >= bbox.x
      && point.y >= bbox.y
      && point.x <= (bbox.x + bbox.width)
      && point.y <= (bbox.y + bbox.height)
}

function bboxesOverlap(a, b) {
  return Boolean(a && b)
      && a.x + a.width >= b.x
      && b.x + b.width >= a.x
      && a.y + a.height >= b.y
      && b.y + b.height >= a.y
}

// The centerpoint of a bounding box
function computeBBoxCenter({ x, y, width, height }) {
  return {
    x: x + width / 2,
    y: y + height / 2,
  }
}

// Computes the angle between vectors c->a and c->b
function computeAngleRadians(a, b, c) {
  const { atan2 } = Math
  return atan2(b.y - c.y, b.x - c.x)
       - atan2(a.y - c.y, a.x - c.x)
}

function computeBBox(points) {
  assert(points.length > 0)

  const { min, max } = Math
  let xmin = Infinity
  let ymin = Infinity
  let xmax = -Infinity
  let ymax = -Infinity
  for (const { x, y } of points) {
    xmin = min(xmin, x)
    xmax = max(xmax, x)
    ymin = min(ymin, y)
    ymax = max(ymax, y)
  }
  return {
    x: xmin,
    y: ymin,
    width: xmax - xmin,
    height: ymax - ymin,
  }
}

function computeBBoxOverlap(bbox1, bbox2) {
  assert(bbox1)
  assert(bbox2)

  const { max, min } = Math

  const xmin = max(bbox1.x, bbox2.x)
  const ymin = max(bbox1.y, bbox2.y)
  const xmax = min(bbox1.x + bbox1.width, bbox2.x + bbox2.width)
  const ymax = min(bbox1.y + bbox1.height, bbox2.y + bbox2.height)

  return {
    x: xmin,
    y: ymin,
    width: xmax - xmin,
    height: ymax - ymin,
  }
}

function getBBoxCorners(bbox) {
  return bbox && {
    tl: {
      x: bbox.x,
      y: bbox.y,
    },
    tr: {
      x: bbox.x + bbox.width,
      y: bbox.y,
    },
    bl: {
      x: bbox.x,
      y: bbox.y + bbox.height,
    },
    br: {
      x: bbox.x + bbox.width,
      y: bbox.y + bbox.height,
    },
  }
}

function distance(p0, p1) {
  return Math.hypot(p1.x - p0.x, p1.y - p0.y)
}

// rotate point p1 about point p2 by angle in radians
function rotate(p1, p2, radians) {
  const { sin, cos } = Math
  // translate so that p2 is the origin
  const x0 = p1.x - p2.x
  const y0 = p1.y - p2.y
  // rotate p1 about that origin
  const x1 = x0 * cos(radians) - y0 * sin(radians)
  const y1 = y0 * cos(radians) + x0 * sin(radians)
  // reverse the translation
  return {
    x: (x1 + p2.x),
    y: (y1 + p2.y),
  }
}

function translate(point, { dx, dy }) {
  return {
    x: point.x + dx,
    y: point.y + dy,
  }
}

function midpoint(p1, p2) {
  return {
    x: (p1.x + p2.x) / 2,
    y: (p1.y + p2.y) / 2,
  }
}


module.exports = {
  bboxContainsPoint,
  bboxesOverlap,
  computeAngleRadians,
  computeBBox,
  computeBBoxCenter,
  computeBBoxOverlap,
  distance,
  getBBoxCorners,
  midpoint,
  rotate,
  translate,
}
